import styles from './separator.module.less';

const Separator = () => (
    <p className={styles.separator}>
        <span>eller</span>
    </p>
);

export default Separator;
